var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultbig(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1025,
    height: 254,
    viewBox: "0 0 1025 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2562_17890)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1025,
    height: 254,
    rx: 16,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.827 78.1667H445.16C438.497 78.1667 433.077 83.5861 433.077 90.2501V162.75C433.077 169.414 438.497 174.833 445.16 174.833H541.827C548.491 174.833 553.91 169.414 553.91 162.75V90.2501C553.91 83.5861 548.491 78.1667 541.827 78.1667ZM460.265 96.2917C462.668 96.2917 464.973 97.2465 466.673 98.9461C468.372 100.646 469.327 102.951 469.327 105.354C469.327 107.758 468.372 110.063 466.673 111.762C464.973 113.462 462.668 114.417 460.265 114.417C457.861 114.417 455.556 113.462 453.856 111.762C452.157 110.063 451.202 107.758 451.202 105.354C451.202 102.951 452.157 100.646 453.856 98.9461C455.556 97.2465 457.861 96.2917 460.265 96.2917ZM493.494 156.708H451.202L475.369 126.5L484.431 138.583L502.556 114.417L535.785 156.708H493.494Z",
    fill: "#BABABA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2562_17890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1025,
    height: 254,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultbig);
export default __webpack_public_path__ + "static/media/defaultbig.2194196fbc5beeda186657520cecfc4b.svg";
export { ForwardRef as ReactComponent };